import { z } from "zod";

export const ExportDataRequestSchema = z.object({
  scopeIds: z.array(z.number().positive().min(1)),
});

export type ExportDataRequest = z.infer<typeof ExportDataRequestSchema>;